import { Component, OnInit } from '@angular/core';
import { SelfService } from '../self-services.service.ts';

import { Router } from '@angular/router';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';

@Component({
  selector: 'app-demographics',
  templateUrl: './demographics.component.html',
  styleUrls: ['./demographics.component.css']
})
export class DemographicsComponent implements OnInit {
  landingDto :any;
  demographicsName:string = "";
  demographicDesc:string = "";
  demograhicId: string;
  editandSavebtn: boolean = false;
  savebtn: boolean = false;
  alertSuccess: boolean;
  alertFailure: boolean;
  alertUpdate: boolean;
  duplicatecheck:any = [];
  demographicsData : any = [];
  timeOutError: boolean;
  timeoutErrorMessage : string = ConstantValues.timeoutErrorMessage;
  
  constructor(private demographicsService :SelfService,
    
    private router: Router,
    private environment : EnvironmentConfiguration) { }

  ngOnInit() {
    if(this.environment.envName == 'dev' || this.environment.envName == 'qa' || this.environment.envName == 'prod'){
   if(localStorage.getItem('loginData') == null || localStorage.getItem('loginData') == undefined ){
      this.router.navigate(['/log-out']);
    }
    }
    this.savebtn = true;
    this.demograhicId = '0';
    this.listDemographics();
  }

  /** For submitting Demographics data
   * @method onSubmit
   */
  public onSubmit() {
    this.timeOutError = false;
    let data = { "demograhicId": this.demograhicId, "demographicsName": this.demographicsName, "demographicDesc": this.demographicDesc, "createdBy": 1, "modifiedBy": 1 };
    this.demographicsService.saveAllDemographics(data).subscribe(data => {

    if(this.editandSavebtn == false){
    for (let i = 0; i < this.demographicsData.length; i++) {
        if (this.demographicsName == this.demographicsData[i].demographicsName) {
          this.alertFailure = true;
          setTimeout(function () {
            this.alertFailure = false;
          }.bind(this), 3000);
          return;
          }
        }
      }

      this.alertSuccess = false;
      this.alertFailure = false;

      if (this.editandSavebtn == true) {
        this.alertUpdate = true;
        setTimeout(function () {
          this.alertUpdate = false;
        }.bind(this), 3000);
      }
      else {
        this.alertSuccess = true;
        setTimeout(function () {
          this.alertSuccess = false;
        }.bind(this), 3000);
      }
      this.listDemographics();
      this.resetDemographics();
    }, err => {
      console.log(JSON.stringify(err.value.message));
      if(err.value.statusText == ConstantValues.unknownError){
                  this.timeOutError = true;
                }
    })
  }

  /** For editing the demographics detail
   * @method editDemographics
   */
  editDemographics(data) {
    this.demographicsName = data.demographicsName;
    this.demographicDesc = data.demographicDesc;
    this.demograhicId = data.demograhicId;
    window.scrollTo({ left: 0, top: 0, behavior:'smooth'});
    this.editandSavebtn = true;
    this.savebtn = false;
  }

  resetDemographics() {
    this.demographicsName = '';
    this.demographicDesc = '';
    this.demograhicId = '0';
    this.editandSavebtn = false;
    this.savebtn = true;
  }

  /** For listing the demographics detail
   * @method listDemographics
   */
  listDemographics() {
    this.timeOutError = false;
    this.demographicsService.getAllDemographics().subscribe(data => {
      this.demographicsData = data;
    }, err => {
      console.log(JSON.stringify(err.value.message));
      if(err.value.statusText == ConstantValues.unknownError){
                  this.timeOutError = true;
                }
    })
  }

  /** For deleting the demographics detail
   * @method deleteDemographics
   */
  deleteDemographics(data) {
    this.timeOutError = false;
    this.demographicsService.deleteDemographic(data.demograhicId).subscribe(data => {
      this.listDemographics();
  },err => {
    console.log(JSON.stringify(err.value.message));
    if(err.value.statusText == ConstantValues.unknownError){
                this.timeOutError = true;
              }
  })
  }
}
